module.exports = __webpack_public_path__ + "img/leader3.eac1993c.jpg";